"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var errorSuffix = "this result is not paginated. Did you call page() in your get() chain?";

var Result = function () {
    function Result(verb, initialisation) {
        _classCallCheck(this, Result);

        this.verb = verb;

        this.status = undefined;
        this.message = undefined;
        this.data = undefined;
        this.page = undefined;

        if (initialisation) {
            var keys = Object.keys(initialisation);

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var key = _step.value;

                    this[key] = initialisation[key];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }

    _createClass(Result, [{
        key: "firstPage",
        value: function firstPage() {
            if (this.verb.firstPage === undefined) {
                var prefix = this.verb.callDetails() + " Result";

                this.verb.log.error(prefix + ".firstPage() - " + errorSuffix);

                return undefined;
            } else {
                return this.verb.firstPage().send();
            }
        }
    }, {
        key: "nextPage",
        value: function nextPage() {
            if (this.verb.firstPage === undefined) {
                var prefix = this.verb.callDetails() + " Result";

                this.verb.log.error(prefix + ".nextPage() - " + errorSuffix + ".");
            } else {
                return this.verb.page(this.page + 1).send();
            }
        }
    }, {
        key: "previousPage",
        value: function previousPage() {
            if (this.verb.firstPage === undefined) {
                var prefix = this.verb.callDetails() + " Result";

                this.verb.log.error(prefix + ".previousPage() - " + errorSuffix);
            } else {
                if (this.page > 0) {
                    return this.verb.page(this.page - 1).send();
                } else {
                    return undefined;
                }
            }
        }
    }, {
        key: "lastPage",
        value: function lastPage() {
            if (this.verb.firstPage === undefined) {
                var prefix = this.verb.callDetails() + " Result";

                this.verb.log.error(prefix + ".previousPage() - " + errorSuffix);
            } else {
                this.verb.log.error(this.prefix + ".lastPage() - tell Harry to implement this!");
            }
        }
    }]);

    return Result;
}();

module.exports = Result;


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/resource/lib/result.js
// module id = 618
// module chunks = 4